<template>
  <div id="app">
    <div class="container-f2g black-container">
      <PaymentOptions
        v-if="!showSuccessComponent && !showErrorComponent && !showSavedCardComponent && !showAutoRechargeModal && !showDisableAutoRechargePrompt"
        ref="payment" />
      <!-- <BottomSeperator  v-if="!showSuccessComponent && !showErrorComponent && !showSavedCardComponent && !showAutoRechargeModal && !showDisableAutoRechargePrompt"/> -->
      <AutoRechargeBanner
        v-if="!showSuccessComponent && !showErrorComponent && !showSavedCardComponent && !showAutoRechargeModal && !showDisableAutoRechargePrompt" />
      <SuccessComponent v-if="showSuccessComponent" />
      <ErrorComponent v-if="showErrorComponent" />
      <WarningModal v-if="showWarningModal" />
      <SavedCard v-if="showSavedCardComponent" />
      <AutoRechargeModal v-if="showAutoRechargeModal && !showDisableAutoRechargePrompt && !showSuccessComponent" />
      <DisableAutoRechargePrompt v-if="showDisableAutoRechargePrompt && !showSuccessComponent" />
    </div>
    <Loader />
  </div>
</template>

<script>
import axios from 'axios'

import Loader from '@/components/Loader.vue'
import BottomSeperator from './components/bottom-seperator.vue'
import PaymentOptions from './components/payment-options.vue'
import SuccessComponent from './components/success.vue'
import ErrorComponent from "./components/error.vue"
import SavedCard from "./components/saved-card.vue"
import AutoRechargeBanner from './components/AutoRechargeBanner'
import AutoRechargeModal from './components/AutoRechargeModal'
import DisableAutoRechargePrompt from './components/DisableAutoRechargePrompt'
import WarningModal from './components/WarningModal'

export default {
  name: 'App',
  components: {
    PaymentOptions,
    SuccessComponent,
    ErrorComponent,
    Loader,
    BottomSeperator,
    SavedCard,
    AutoRechargeBanner,
    AutoRechargeModal,
    DisableAutoRechargePrompt,
    WarningModal
  },
  data: function () {
    return {

    }
  },
  created() {
    console.log("Created");
    this.checkUrlStatus();
    this.$store.commit("setEmail", document.getElementById("user-info").dataset.email);

    let locale = document.getElementsByTagName("BODY")[0].getAttribute("data-locale")
    let isDevMode = document.getElementsByTagName("BODY")[0].getAttribute("data-devmode") == "true" || false;

    let username = document.getElementById("user-info").getAttribute("data-username")
    let msisdn = document.getElementById("user-info").getAttribute("data-msisdn")
    let email = document.getElementById("user-info").getAttribute("data-email")
    let otpUser = document.getElementById("user-info").getAttribute("data-otpUser")


    let loginInfo = {
      "username": username,
      "msisdn": msisdn,
      "email": email,
      "otpUser": otpUser
    }

    this.$store.commit("setLocale", locale);
    this.$store.commit("isDevMode", isDevMode);
    this.$store.commit("setLoginInfo", loginInfo);

  },
  computed: {
    isDevMode() {
      return this.$store.state.isDevMode;
    },
    showSuccessComponent() {
      return this.$store.state.showSuccessComponent;
    },
    showErrorComponent() {
      return this.$store.state.showErrorComponent;
    },
    showWarningModal() {
      return this.$store.state.showWarningModal;
    },
    showSavedCardComponent() {
      return this.$store.state.showSavedCardComponent;
    },
    showAutoRechargeModal() {
      return this.$store.state.showAutoRechargeModal;
    },
    showDisableAutoRechargePrompt() {
      return this.$store.state.showDisableAutoRechargePrompt;
    },
    locale() {
      return this.$store.state.locale;
    },
    language() {
      if (this.locale == 'en_US') {
        return 'en'
      } else {
        return 'gr'
      }
    }
  },
  methods: {
    checkUrlStatus() {
      console.log("Checking url status");
      this.$store.commit('showLoader');
      var urlParams = new URLSearchParams(window.location.search);
      var status = urlParams.get('status');
      var errorFromBank = urlParams.get('errorFromBank');
      if (status != null) {
        if (status == 'OK') {
          var msisdn = urlParams.get('msisdn');
          var amount = urlParams.get('amount');
          var transactionCode = urlParams.get('transactionCode');
          var isReccuring = (urlParams.get('recurring') == "true");
          var recurringDate = urlParams.get('recurringDate');
          var recurringAmount = urlParams.get('recurringAmount');

          amount = Math.round(amount);

          this.$store.commit("setUrlParamMsisdn", msisdn);
          this.$store.commit("setUrlParamAmount", amount);
          this.$store.commit("setUrlParamTransactionCode", transactionCode);

          this.$store.commit("setUrlParamIsReccuring", isReccuring);
          this.$store.commit("setUrlParamRecurringDate", recurringDate);
          this.$store.commit("setUrlParamRecurringAmount", recurringAmount);

          //if cookie for datajump exists make datajumpsession true and remove the cookie
          if (this.cookieExists("dataJumpSession")) {
            this.$store.commit("setIsDataJumpSession", true);
            document.cookie = "dataJumpSession" + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
          }

          $(document).on("initDataLayer", function () {
            var dataLayerObj = {
              "event": "topup-online",
              "currency": "EUR",
              "value": amount.toFixed(2),
              "loggedin": "yes",
            }
            handleDataLayer.init();
            handleDataLayer.pushDataLayer(dataLayerObj);

          })

          this.$store.commit('showSuccessComponent', true);
          this.$store.commit('hideLoader');
          console.log("successfull transaction")
        } else if (status == 'NOK') {
          this.$store.commit('setErrorFromBank', errorFromBank);
          this.$store.commit('showErrorComponent', true);
          console.log("unsuccessfull transaction")
          this.$store.commit('hideLoader');

        }
      } else {
        // check if dataJumpFlow exists
        var dataJumpFlow = urlParams.get('dataJumpFlow');
        this.$store.commit("setIsDataJumpFlow", !!dataJumpFlow);

        //destroy the datajump cookie if exists
        if (this.cookieExists("dataJumpSession")) {
          document.cookie = "dataJumpSession" + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }

        this.checkSessionStorage();
      }
    },
    cookieExists(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return true;
        }
      }
      return false;
    },
    checkSessionStorage() {
      //  var url = new URL(window.location.href);
      //  var token = url.searchParams.get("token");

      //remove cookie if exists
      document.cookie = "dataJumpSession" + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      var token = sessionStorage.getItem('token');
      var activeFlowState = sessionStorage.getItem('activeFlow_' + "F2G_" + token);
      if (activeFlowState == "false") {
        this.$store.commit("setActiveFlow", false);
        this.$store.commit('showErrorComponent', true);
        this.$store.commit('hideLoader');
      } else {
        this.generateToken();
      }
    },
    generateToken() {
      var msisdn = document.getElementById("user-info").dataset.msisdn;
      var payload = {};
      payload.msisdn = msisdn;
      payload = this.addCaller(payload);

      var config = {
        method: 'post',
        url: '/apiv2/topup/generateToken',
        data: payload
      }

      if (document.getElementsByTagName("BODY")[0].getAttribute("data-devmode") == "true" || false) {
        config.headers = {
          "oidc-telephonenumber": msisdn
        }
      }

      axios(config).then(response => {
        if (response.data.success) {
          console.log('generateToken ' + JSON.stringify(response.data));
          this.$store.commit("setToken", response.data.token);
          sessionStorage.setItem("token", response.data.token);
          this.$refs.payment.getUserProfileAndTariffs();
        } else {
          console.log('generateToken response: ' + JSON.stringify(response.data));

          this.$store.commit('showErrorComponent', true);
          this.$store.commit('hideLoader');
        }
      }).catch(error => {
        console.log("generateToken responded with error: " + error);
        if (error == "Error: Request failed with status code 401") {
          window.location.href = "/" + this.language + "/f2g/my-free-2-go/login/"
        }

        this.$store.commit('showErrorComponent', true);

        this.$store.commit('hideLoader');

      })
      console.log("msisdn is : " + msisdn);
    },
    addCaller: function addCaller(input) {
      var inputWithCaller;
      inputWithCaller = input;
      var caller = {
        "callingSystem": "myF2Gweb",
        "salesCode": "",
        "username": "username",
        "channel": "F2G",
        "data": "",
      };
      caller.locale = (document.getElementsByTagName("body")[0].dataset.locale != "null") ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";
      inputWithCaller.caller = caller;
      return inputWithCaller;
    },
  }
}

</script>

<style>
</style>
